import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a02374a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a02374a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a02374a')) {
      api.createRecord('2a02374a', component.options)
    } else {
      api.reload('2a02374a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a02374a&scoped=true", function () {
      api.rerender('2a02374a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/deposit/index.vue"
export default component.exports